import { getScopedClient } from './supabase';

export interface AdvisorProfile {
  location_id: string;
  advisor_name: string;
  advisor_title: string;
  credentials: string;
  company_name: string;
  advisor_email: string;
  advisor_phone: string;
  website: string;
  bio: string;
  advisor_headshot: string;
  company_logo: string;
  cta_link: string;
}

const PROFILE_FIELDS = [
  'location_id',
  'advisor_name',
  'advisor_title',
  'credentials',
  'company_name',
  'advisor_email',
  'advisor_phone',
  'website',
  'bio',
  'advisor_headshot',
  'company_logo',
  'cta_link',
] as const;

export async function getProfile(locationId: string): Promise<AdvisorProfile | null> {
  const client = getScopedClient();
  const { data, error } = await client
    .from('branding')
    .select(PROFILE_FIELDS.join(','))
    .eq('location_id', locationId)
    .single();

  if (error || !data) return null;
  return data as unknown as AdvisorProfile;
}

export async function upsertProfile(
  profile: Partial<AdvisorProfile> & { location_id: string }
): Promise<void> {
  const client = getScopedClient();
  const { error } = await client
    .from('branding')
    .upsert(profile, { onConflict: 'location_id' });

  if (error) {
    throw new Error(`Failed to save profile: ${error.message}`);
  }
}
